module.exports = __webpack_public_path__ + "static/ist-40ae1fb091de3287d037292f63c08281.jpg";